import script from "./DestinationSection.vue?vue&type=script&setup=true&lang=js"
export * from "./DestinationSection.vue?vue&type=script&setup=true&lang=js"

import "./DestinationSection.vue?vue&type=style&index=0&id=aa337a6e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa337a6e"]])

export default __exports__